<template>
    <div class="contents">
        <div class="inner">
            <div class="cont-tit">
                <h2 class="page-title">Portfolio</h2>
                <p class="page-desc">Our portfolio demonstrates our capabilities and expertise through a variety of projects and success stories. <br>
                    Each project is the result of our best efforts to meet our customers' needs and provide innovative solutions.
                </p>
            </div>

            <div class="portfolio">
                <div class="portfolio__box">
                    <p class="design-text">Mobility Industry</p>
                    <div class="portfolio__box-wrap">
                        <div class="portfolio__img" @click="imgText1 = !imgText1">
                            <img src="../assets/resource/img/portfolio01.png" alt="">
                            <ul class="portfolio__list" :class="{active: imgText1}">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>A business that builds a PC/mobile platform that can provide online/offline linked services</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>Designed considering a mobile-first responsive web.</li>
                                        <li>Separate IDs for Blue Members Point Mall and Genesis Point Mall.</li>
                                        <li>Product registration function.</li>
                                        <li>Check history such as shopping cart and purchase history.</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Cookie important information detection option</li>
                                        <li>Delete payment-related buttons and text such as shopping cart, payment, etc <br>
                                            Developed in the form of an email inquiry</li>
                                        <li>Connecting B2C Integrated Managers</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="portfolio__text">
                            <h3>[Hyundai Motors Genesis] <br>
                                Establishment of O2O platform linkage</h3>
                            <ul class="portfolio__list">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>A business that builds a PC/mobile platform that can provide online/offline linked services</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>Designed considering a mobile-first responsive web.</li>
                                        <li>Separate IDs for Blue Members Point Mall and Genesis Point Mall.</li>
                                        <li>Product registration function.</li>
                                        <li>Check history such as shopping cart and purchase history.</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Cookie important information detection option</li>
                                        <li>Delete payment-related buttons and text such as shopping cart, payment, etc <br>
                                            Developed in the form of an email inquiry</li>
                                        <li>Connecting B2C Integrated Managers</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="portfolio__box reverse">
                    <div class="portfolio__box-wrap">
                        <div class="portfolio__img" @click="imgText2 = !imgText2">
                            <img src="../assets/resource/img/portfolio02.png" alt="">
                            <ul class="portfolio__list" :class="{active: imgText2}">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>Build a mobile O2O platform into a PC structure</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>Among O2O platforms, the payment process is linked to the API</li>
                                        <li>Built on Android and iOS</li>
                                        <li>Linked to Red Members point payments as a means of identity verification.</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Building a mobile O2O platform into a PC structure</li>
                                        <li>Establishment of service reservation part separately for franchise management
                                            among O2O platforms</li>
                                        <li>Shopping mall order collection, invoice transmission, product registration
                                            and modification, and out of stock processing</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="portfolio__text">
                            <h3>Construction and operation of Kia <br>
                                Motors Kia Red Members Mall</h3>
                            <ul class="portfolio__list">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>Build a mobile O2O platform into a PC structure</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>Among O2O platforms, the payment process is linked to the API</li>
                                        <li>Built on Android and iOS</li>
                                        <li>Linked to Red Members point payments as a means of identity verification.</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Building a mobile O2O platform into a PC structure</li>
                                        <li>Establishment of service reservation part separately for franchise management
                                            among O2O platforms</li>
                                        <li>Shopping mall order collection, invoice transmission, product registration
                                            and modification, and out of stock processing</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="portfolio__box">
                    <div class="portfolio__box-wrap">
                        <div class="portfolio__img" @click="imgText3 = !imgText3">
                            <img src="../assets/resource/img/portfolio03.png" alt="">
                            <ul class="portfolio__list" :class="{active : imgText3}">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>Development of internal/external linkage and realization of information protection system for stable Auto& shopping mall IT system</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>[Connection] Internal mall and external mall collector</li>
                                        <li>[Connection] Establishment of API for smooth communication between collection/transmitter</li>
                                        <li>[Connection] Establishment of transmitter for ERP linkage</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Establishment of each shopping mall order, invoice, product, out of stock, claim,
                                            statistical verification management system</li>
                                        <li>Connect to enable CTI order processing and invoice processing</li>
                                        <li>Implementing Settlement and Tax Statement Batch</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="portfolio__text">
                            <h3>[Auto& Co., Ltd.] O2O platform linkage <br>
                                construction and integrated operation</h3>
                            <ul class="portfolio__list">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>Development of internal/external linkage and realization of information protection system for stable Auto& shopping mall IT system</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>[Connection] Internal mall and external mall collector</li>
                                        <li>[Connection] Establishment of API for smooth communication between collection/transmitter</li>
                                        <li>[Connection] Establishment of transmitter for ERP linkage</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Establishment of each shopping mall order, invoice, product, out of stock, claim,
                                            statistical verification management system</li>
                                        <li>Connect to enable CTI order processing and invoice processing</li>
                                        <li>Implementing Settlement and Tax Statement Batch</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="portfolio__box reverse">
                    <div class="portfolio__box-wrap">
                        <div class="portfolio__img" @click="imgText4 = !imgText4">
                            <img src="../assets/resource/img/portfolio04.png" alt="">
                            <ul class="portfolio__list" :class="{active: imgText4}">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>A business that builds a PC/mobile platform that can provide online/offline linked services.</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>O2O service deployment (including development services, purchase of S/W)</li>
                                        <li>Renewal of B2C Platform</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Mobile Web Builds Hybrid Apps</li>
                                        <li>Screen configuration that can be used as a POS or as a tablet</li>
                                        <li>Built to enable purchase of goods within supplier and merchant systems</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="portfolio__text">
                            <h3>Establishment of O2O linked shopping mall <br>
                                for Auto & Hyundai Commercial Co., Ltd.</h3>
                            <ul class="portfolio__list">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>A business that builds a PC/mobile platform that can provide online/offline linked services.</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>O2O service deployment (including development services, purchase of S/W)</li>
                                        <li>Renewal of B2C Platform</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Mobile Web Builds Hybrid Apps</li>
                                        <li>Screen configuration that can be used as a POS or as a tablet</li>
                                        <li>Built to enable purchase of goods within supplier and merchant systems</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="portfolio__box mt80">
                    <p class="design-text right">Golf Supplies Industry</p>
                    <div class="portfolio__box-wrap">
                        <div class="portfolio__img" @click="imgText5 = !imgText5">
                            <img src="../assets/resource/img/portfolio05.png" alt="">
                            <ul class="portfolio__list" :class="{active : imgText5}">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>C2C, B2C used golf club e-commerce platform Build front based on hybrid app,
                                        and build affiliated store and integrated manager page</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>Building a front bAased on C2C, B2C used golf club e-commerce platform hybrid app</li>
                                        <li>Establishment of a dedicated site for affiliated stores</li>
                                        <li>Establishment of integrated administrator site</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Building a used e-commerce shopping mall as a hybrid, C2C front product registration function,
                                            Golf club diagnostic information, market price graph for actual transaction on the platform, community</li>
                                        <li>Affiliated store B2C Product Registration and Management</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="portfolio__text">
                            <h3>True Golf</h3>
                            <ul class="portfolio__list">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>C2C, B2C used golf club e-commerce platform Build front based on hybrid app,
                                        and build affiliated store and integrated manager page</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>Building a front bAased on C2C, B2C used golf club e-commerce platform hybrid app</li>
                                        <li>Establishment of a dedicated site for affiliated stores</li>
                                        <li>Establishment of integrated administrator site</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Building a used e-commerce shopping mall as a hybrid, C2C front product registration function,
                                            Golf club diagnostic information, market price graph for actual transaction on the platform, community</li>
                                        <li>Affiliated store B2C Product Registration and Management</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="portfolio__box reverse mt80">
                    <p class="design-text">Pet, Companion Animal Industry</p>
                    <div class="portfolio__box-wrap">
                        <div class="portfolio__img" @click="imgText6 = !imgText6">
                            <img src="../assets/resource/img/portfolio06.png" alt="">
                            <ul class="portfolio__list" :class="{active: imgText6}">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>Establishment of an O2O platform for product commerce and offline service reservations</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <p>
                                        E-commerce shopping mall for pet products, establishing a platform for reservation of O2O services as a hybrid, establishing a site exclusively for merchants and stores, and establishing an integrated manager
                                        site
                                    </p>

                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Establishment of the front of the O2O platform, establishment of a B2C manager page exclusively for stores and merchants, and establishment of an integrated manager site</li>
                                        <li>Create offline service reservation management, order management, create and comments</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="portfolio__text">
                            <h3>Petarium O2O platform construction</h3>
                            <ul class="portfolio__list">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>Establishment of an O2O platform for product commerce and offline service reservations</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <p>
                                        E-commerce shopping mall for pet products, establishing a platform for reservation of O2O services as a hybrid, establishing a site exclusively for merchants and stores, and establishing an integrated manager
                                        site
                                    </p>

                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Establishment of the front of the O2O platform, establishment of a B2C manager page exclusively for stores and merchants, and establishment of an integrated manager site</li>
                                        <li>Create offline service reservation management, order management, create and comments</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="portfolio__box">
                    <div class="portfolio__box-wrap">
                        <div class="portfolio__img" @click="imgText7 = !imgText7">
                            <img src="../assets/resource/img/portfolio07.png" alt="">
                            <ul class="portfolio__list" :class="{active: imgText7}">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>Analyzing the current status of pet services and planning an integrated reservation system, Designing a XaaS model that can be used by a variety of companies.</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>Comprehensive pet service model design</li>
                                        <li>Membership/subscription-based process design, pet-specific merchant/supplier integrated management</li>
                                        <li>Collection of pet behavior data</li>
                                        <li>Creating a cloud-based infrastructure environment</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Introducing the XaaS model (O2O platform) to the pet industry, which had previously relied on the offline model</li>
                                        <li>Providing digital transformation and pet online integrated services</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="portfolio__text">
                            <h3>National IT Industry Promotion Agency <br>
                                XaaS Leading Project Project</h3>
                            <ul class="portfolio__list">
                                <li class="portfolio__item">
                                    <h4>business purpose</h4>
                                    <p>Analyzing the current status of pet services and planning an integrated reservation system, Designing a XaaS model that can be used by a variety of companies.</p>
                                </li>
                                <li class="portfolio__item">
                                    <h4>scope of business</h4>
                                    <ul>
                                        <li>Comprehensive pet service model design</li>
                                        <li>Membership/subscription-based process design, pet-specific merchant/supplier integrated management</li>
                                        <li>Collection of pet behavior data</li>
                                        <li>Creating a cloud-based infrastructure environment</li>
                                    </ul>
                                </li>
                                <li class="portfolio__item">
                                    <h4>Business conduct details</h4>
                                    <ul>
                                        <li>Introducing the XaaS model (O2O platform) to the pet industry, which had previously relied on the offline model</li>
                                        <li>Providing digital transformation and pet online integrated services</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                imgText1: false,
                imgText2: false,
                imgText3: false,
                imgText4: false,
                imgText5: false,
                imgText6: false,
                imgText7: false
            }
        },
        created() {
            this.country = localStorage.getItem("country");
            this.place = localStorage.getItem("place");
        },

    }
</script>